// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"📚4-7-02eSb_","size_minus-1":"📚4-7-01fPal","size_0":"📚4-7-029fVJ","size_1":"📚4-7-01ExO1"};